import React, {useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import {Field, Form, Formik} from 'formik';
import FieldLabel from '../admin/quickApplications/CreateQuickApplication/components/FieldLabel';
import MaterialSelect from '../admin/quickApplications/CreateQuickApplication/components/MaterialSelect';
import {apvgkService} from "../../services/apvgkService";
import Button from "@material-ui/core/Button";


const Filter = ({ currentFilters, onFiltersChange }) => {
    const [apvgks, setApvgks] = useState([]);
    const fetchPage = async (page) =>  {
        const response = await apvgkService.getPage(page, 1000, false);
        setApvgks(response.data);
    }
    useEffect(() => {
        fetchPage(1);
    }, [])
    return (
        <Grid item xs={12}>
            <Formik
                initialValues={{...currentFilters} }
                onSubmit={values => {
                    onFiltersChange(values);
                }}
                validateOnChange={false}
                validateOnBlur={false}
                render={({ values, setFieldValue }) => (
                    <Form>
                        <FieldLabel label="Наименование АПВГК" name="apvgk_id">
                            <Field
                                name="apvgk_id"
                                placeholder="Выберите АПВГК"
                                component={MaterialSelect}
                                options={apvgks.map((v) => {return {value:v.id, label:v.name};})}
                            />
                        </FieldLabel>
                        <Button
                            variant="contained"
                            color="primary"
                            className="btn-add no-margin"
                            type="submit"
                        >
                            Обновить
                        </Button>
                    </Form>
                )}
            />
        </Grid>
    );
};

export default Filter;
